module.exports = __webpack_public_path__ + "static/img/B (2).7fe09820.png";